
import api from "@/api/index"; //ABP API接口
import {Vue, Component} from "vue-property-decorator";
import {ElementTableView} from "@/lib/ElementTableView";
import {MessageBox} from "element-ui";

import {PayOrderDto} from "@/api/appService";
import ExportButton from "@/components/ExportButton/index.vue";

@Component({
  name: "PayOrderList",
  components: {ExportButton}
})
export default class PayOrderList extends ElementTableView {
  tableItems: PayOrderDto[] = [];
  private payOrderQueryForm: any = {
    billNo: '',
    isSuccessPay: undefined,
    yearMonth: ''
  };

  async created() {
    await this.fetchData();
  }


  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    let pageParam = {
      sorting: this.table.sorting,
      from: this.queryForm.from,
      to: this.queryForm.to,
      skipCount: this.skipCount,
      maxResultCount: this.table.pagesize
    };
    await api.payOrder
        .getAll(Object.assign(pageParam, this.payOrderQueryForm))
        .then(res => {
          console.log(res);
          this.table.listLoading = false;
          this.tableItems = res.items!;
          this.table.totalCount = res.totalCount!;
        });
  }

  async handleView(row: PayOrderDto) {
    console.log(row);
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }
}
